/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import ExternalContent from './external/ExternalContent';
import ForeseeContent from './foresee/ForeseeContent';
import SamlContent from './saml/SamlContent';
import ApplicationContent from './application/ApplicationContent';
var content = {
  external: ExternalContent,
  foresee: ForeseeContent,
  saml: SamlContent,
  application: ApplicationContent
};
export default (function (confirmationType) {
  return content[confirmationType] || ExternalContent;
});